export enum Size {
  SMALL = 'sizeSmall',
  MEDIUM = 'sizeMedium',
  LARGE = 'sizeLarge',
}

export enum BBBVariant {
  EXTENDED_TEXT,
  SHORT_TEXT,
  NO_TEXT,
}
